<ul
  class="filter-switch"
  [ngClass]="cssClass"
>
  @for (
    item of items;
    track $index
    ) {
    <li
      [ngClass]="
        listItemClass
      "
    >
      <button
        type="button"
        class="
          btn
          text-center
        "
        [ngClass]="
          getItemClasses(
            item
          )
        "
        [class.active]="
          item.libItemTemplate ===
            activeItem &&
          !item.disabled
        "
        [style.opacity]="
          item.disabled
            ? '.2'
            : null
        "
        [attr.aria-disabled]="
          item.disabled
        "
        (click)="
          !item.disabled &&
          selectItem(
            item.libItemTemplate
          )
        "
      >
        <ng-container
          [ngTemplateOutlet]="
            item.templateRef
          "
        >
        </ng-container>
      </button>
    </li>
  }
</ul>
